// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
	itemsMenu.forEach((itemMenu)=>{
		if (itemMenu.querySelector('.submenu')) {
			const event =[ "mouseenter", "mouseleave"];
			event.forEach((event) => {
				itemMenu.addEventListener(event, () => {
					itemMenu.classList.toggle('hover')
					itemMenu.querySelector('.submenu').classList.toggle('show')
				})
			})
		}
	})

    window.onload = function() {
		/* updateMenuTabIndex();
		const menu = document.querySelector('#menu-container');
		if (menu) {
			menu.addEventListener('transitionend', updateMenuTabIndex);
		}  */

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		});
		
	};

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	//LBX custom gallery
	const customLbx = new LBX('.js-custom-lbx');
	customLbx.icons.next = 
		'<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="55" height="55" viewBox="0 0 55 55"><g id="Arrow"><polygon points="25.29 36.1 23.53 34.32 30.35 27.5 23.53 20.68 25.29 18.9 34.06 27.5 25.29 36.1" style="fill: #fff;"/></g><g id="Arrows"><g id="ArrowRight-Hover"><g id="BOX" style="isolation: isolate;"><path d="M55,54.99H0V.01h55v54.97Z" style="fill: #1e354b;"/></g><path id="Arrow-2" data-name="Arrow" d="M37.56,27.29c.33.33.33.87,0,1.2h0l-14.28,14.38c-.33.33-.85.33-1.18,0,0,0,0,0,0,0-.33-.33-.33-.87,0-1.2l13.68-13.78-13.7-13.78c-.33-.33-.33-.87,0-1.2.32-.33.85-.33,1.18,0,0,0,0,0,0,0h0l14.29,14.38Z" style="fill: #fff;"/></g></g></svg>'
	customLbx.icons.close = 
		'<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="41.25" height="41.25" viewBox="0 0 41.25 41.25"><g><g id="Arrow"><polygon points="15.17 27.41 13.78 26 19.16 20.62 13.78 15.25 15.17 13.84 22.08 20.62 15.17 27.41" style="fill: #fff;"/></g><g id="Arrow-2" data-name="Arrow"><polygon points="26.08 27.41 27.47 26 22.09 20.62 27.47 15.25 26.08 13.84 19.17 20.62 26.08 27.41" style="fill: #fff;"/></g></g><g id="Arrows"><g id="ArrowRight-Hover"><g id="BOX" style="isolation: isolate;"><path d="M41.25,41.24H0V.01h41.25v41.23Z" style="fill: #1e354b;"/></g><path d="M21.4,20.66s0-.05,0-.08l10.23-10.3c.25-.25.25-.65,0-.9-.24-.25-.64-.25-.89,0,0,0,0,0,0,0l-10.12,10.18-10.12-10.18s0,0,0,0c-.25-.24-.64-.24-.89,0-.25.25-.25.65,0,.9l10.23,10.3s0,.05,0,.08l-10.22,10.3c-.25.25-.25.65,0,.9,0,0,0,0,0,0,.25.24.64.24.89,0l10.11-10.18,10.11,10.18c.24.25.64.25.89,0,0,0,0,0,0,0,.25-.25.25-.65,0-.9l-10.22-10.3Z" style="fill: #fff;"/></g></g></svg>'
	customLbx.icons.prev = 
		'<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="55" height="55" viewBox="0 0 55 55"><g id="Arrow"><polygon points="25.29 36.1 23.53 34.32 30.35 27.5 23.53 20.68 25.29 18.9 34.06 27.5 25.29 36.1" style="fill: #fff;"/></g><g id="Arrows"><g id="ArrowRight-Hover"><g id="BOX" style="isolation: isolate;"><path d="M55,54.99H0V.01h55v54.97Z" style="fill: #1e354b;"/></g><path id="Arrow-2" data-name="Arrow" d="M37.56,27.29c.33.33.33.87,0,1.2h0l-14.28,14.38c-.33.33-.85.33-1.18,0,0,0,0,0,0,0-.33-.33-.33-.87,0-1.2l13.68-13.78-13.7-13.78c-.33-.33-.33-.87,0-1.2.32-.33.85-.33,1.18,0,0,0,0,0,0,0h0l14.29,14.38Z" style="fill: #fff;"/></g></g></svg>'

	if(document.querySelector('.expand-submenu')){
		document.querySelectorAll('.expand-submenu').forEach((expand)=>{
			expand.addEventListener('click', ()=>{
				expand.classList.toggle('active-menu');
				expand.nextElementSibling.classList.toggle('show');
			})
		})
	}

	if(document.getElementById("form_id-246")) {
		let policyLabel = document.querySelector('#form_id-246 label[for="form_id-246-privacy_termsemail-signup"]');
		let policyLink = policyLabel.querySelector('a');
		policyLink.href = "https://www.marriott.com/about/privacy.mi"
		
	}
	
})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	let logoHeaderImg = document.querySelector(".js-scroll-logo img");
	let logoHeader = `${site_url}assets/svg/viva-anaheim-logo.svg`;
	let logoHeaderScroll = `${site_url}assets/svg/viva-anaheim-scroll-logo.svg`;

	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
				if(logoHeaderImg)
					logoHeaderImg.setAttribute("src", logoHeaderScroll);
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
				if(logoHeaderImg)
					logoHeaderImg.setAttribute("src", logoHeaderScroll);
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
			if(logoHeaderImg)
				logoHeaderImg.setAttribute("src", logoHeader);
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

document.querySelectorAll('.js-open-menu').forEach((open)=>{
	open.addEventListener('click',()=>{
		document.getElementById('menu-container').classList.add('show');
	})
})

document.querySelectorAll('.js-close-menu').forEach((close)=>{
	close.addEventListener('click',()=>{
		document.getElementById('menu-container').classList.remove('show');
	})
})

document.querySelectorAll(`#privary-navigation li a`).forEach(anchor => {
	if(!anchor.nextElementSibling){
		anchor.addEventListener('click', e => {
			document.getElementById('menu-container').classList.remove('show');
		})
	}
});

document.querySelectorAll('.btn:not(.reset)').forEach((button)=>{
	let span = document.createElement('span');
	button.insertAdjacentElement('afterbegin', span);
});

document.querySelectorAll('.btn-black:not(.reset)').forEach((button)=>{
	let span = document.createElement('span');
	button.insertAdjacentElement('afterbegin', span);
});

const tablesResp = document.querySelectorAll('.capacity-chart__copy table');
if (tablesResp.length) {
	tablesResp.forEach((tablei) => {
		let tableresponsive = document.createElement('div')
		tableresponsive.classList.add('tableHold')
		tablei.parentNode.insertBefore(tableresponsive, tablei)
		tableresponsive.append(tablei)
		const ths = tablei.querySelectorAll('tr:first-child > *')
		tablei.querySelectorAll('tr + tr').forEach((row) => {
			const tds = row.querySelectorAll('td')
			let i = 0
			for (i; i < tds.length; i++) {
				tds[i].setAttribute('data-label', ths[i].textContent)
			}
		})
		const rowHeads = tablei.querySelectorAll('tr td:first-child')
		rowHeads.forEach((ele) => {
			ele.addEventListener('click', (ev) => {
				ele.closest('tr').classList.toggle('active')
			})
		})
	})
}

/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/

function updateMenuTabIndex() {
	const menu = document.querySelector('#menu-container');
	const isMenuVisible = menu && menu.classList.contains('show');
	const elements = document.querySelectorAll('#menu-container .privary-navigation__item a, #menu-container .social-media a');

	elements.forEach(element => {
		element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
	});
} 
